// Фильтры карты /tutors в адресе: ?type=tutor|club&subject=<code>&district=<code>.
// Пишет главная (дверь «Репетиторы и кружки рядом с домом»), читает /tutors
// при загрузке. Коды — из map-taxonomy.json; чужой или устаревший код молча
// отбрасывается, а не ломает страницу: карта откроется без этого фильтра.
// Проверка — scripts/verify-home-doors.mts.
import { isDistrict, isSubjectOf, type PartnerKind } from "@/data/map-taxonomy";

export type MapQuery = { layer: PartnerKind | null; subject: string; district: string; city: string };

export function parseMapQuery(search: string): MapQuery {
  const q = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const type = q.get("type");
  const layer: PartnerKind | null = type === "tutor" || type === "club" ? type : null;
  const rawSubject = (q.get("subject") ?? "").trim();
  const rawDistrict = (q.get("district") ?? "").trim();
  // Предмет проверяется по справочнику своего слоя; без type — по репетиторам
  // (слой /tutors по умолчанию).
  const subject = rawSubject && isSubjectOf(layer ?? "tutor", rawSubject) ? rawSubject : "";
  const district = rawDistrict && isDistrict(rawDistrict) ? rawDistrict : "";
  const rawCity = (q.get("city") ?? "").trim();
  // Код города — строка map_cities (или «all»); есть ли он в фильтре, решает страница карты.
  const city = /^[a-z_]{2,40}$/.test(rawCity) ? rawCity : "";
  return { layer, subject, district, city };
}

/** Адрес карты — в map-href.ts (без справочника, для главной); здесь — тот же экспорт. */
export { mapQueryHref } from "./map-href";
